import React, { forwardRef, useState } from 'react';
import './custom.css';
import DatePicker from "react-datepicker";
import TextField from '@mui/material/TextField';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ListItemIcon from '@mui/material/ListItemIcon';

function CustomDateTimePicker() {  
  const [dateTime, setDateTime] = useState(new Date());

  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <TextField
      label="Outbound Date"
      variant="outlined"
      className="example-custom-input" 
      onClick={onClick} ref={ref}
      value={value}
      InputProps={{
        startAdornment: (
          <ListItemIcon>
            <CalendarTodayIcon />
          </ListItemIcon>
        ),
      }}
      fullWidth
    />
  ));
  return (
    
    <DatePicker
              selected={dateTime}
              onChange={date => setDateTime(date)}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              timeCaption="Departure Time"
              dateFormat="MMMM d, yyyy h:mm aa"
              customInput={<ExampleCustomInput />}
    />
       
  );
}

export default CustomDateTimePicker;
